import { FiMoon, FiSun, FiMonitor } from 'react-icons/fi';
import { useTheme } from '../../../context/ThemeContext';
import SettingsCard from '../../../components/ui/SettingsCard';
import SegmentedControl from '../../../components/ui/SegmentedControl';

const THEME_OPTIONS = [
  { value: 'dark', label: 'Dark', icon: FiMoon },
  { value: 'light', label: 'Light', icon: FiSun },
  { value: 'system', label: 'System', icon: FiMonitor },
];

const DENSITY_OPTIONS = [
  { value: 'comfortable', label: 'Comfortable' },
  { value: 'compact', label: 'Compact' },
];

export default function AppearanceSettings() {
  const { themePreference, setThemePreference, densityPreference, setDensityPreference } = useTheme();

  return (
    <div className="page settings-page">
      <header className="settings-tab-header">
        <h1 className="settings-tab-title">Appearance</h1>
        <p className="text-muted">Control how FieldCert looks on this account.</p>
      </header>

      <SettingsCard
        title="Theme"
        hint="Choose how FieldCert looks. System follows your device setting."
      >
        <SegmentedControl
          ariaLabel="Theme"
          value={themePreference}
          onChange={setThemePreference}
          options={THEME_OPTIONS.map(({ value, label, icon: Icon }) => ({
            value,
            label: (
              <>
                <Icon size={16} aria-hidden /> {label}
              </>
            ),
          }))}
        />
      </SettingsCard>

      <SettingsCard
        title="Density"
        hint="Compact tightens row spacing in tables and lists."
      >
        <SegmentedControl
          ariaLabel="Density"
          value={densityPreference}
          onChange={setDensityPreference}
          options={DENSITY_OPTIONS}
        />
      </SettingsCard>
    </div>
  );
}
